const dealerRequests = {
  header: 'Liste des installateurs',
  dealer_requests: 'Demandes des installateurs',
  search_dealers: 'Rechercher un installateur',
  confirm_modal_confirm: 'Oui, supprimer',
  no_pending_requests: 'Aucune demande en attente',
  approved: 'Approuvé',
  pending: 'En Attente',
  denied: 'Refusé',
  in_review: 'En Revue',
  approve: 'Approuver',
  deny: 'Refuser',
  review: 'Revue',
  all: 'Tout',
  submit: 'Soumettre',
  update: 'Mise à jour',
  edit: 'Modifier',
  history: 'Historique',
  email_notifications: 'Notifications par courriel',
  email_modal_description:
    "Cette liste de courriels recevra la candidature d'installateur",
  email_list_updated:
    "Liste de diffusion des demandes d'installateur mise à jour",
  dealer_request_updated: "Demande d'installateur mise à jour",
  table: {
    company: 'ENTREPRISE',
    full_name: 'NOM ET PRÉNOM',
    email: 'EMAIL',
    country: 'PAYS',
    date: 'DATE',
    status: 'ÉTAT',
  },
};

export default dealerRequests;
